var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center py-5"},[_c('img',{staticClass:"w-25",attrs:{"src":require("@/assets/dashboard/icon/EmptyState.png"),"alt":""}}),_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }